import $ from 'jquery';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

const namespace = 'blog-navigation';

export default class BlogNavigation {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          trigger: '[data-blog-nav-trigger]',
          close: '[data-blog-nav-close]',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );

    this.$el = $(el);
    this.el = this.$el.get(0);
    this.$triggers = $(this.options.selectors.trigger);

    this.bind();
  }

  /**
   * Apply event listeners
   */
  bind() {
    $(this.options.selectors.trigger).on(
      `click.trigger.${namespace}`,
      this.open.bind(this),
    );

    this.$el.on(
      `click.close.${namespace}`,
      this.options.selectors.close,
      this.close.bind(this),
    );
  }
  
  unbind() {
    $(this.options.selectors.trigger).off(`click.trigger.${namespace}`);
    this.$el.off(`click.close.${namespace}`);
  }

  open() {
    disableBodyScroll(this.el);
    this.$el.addClass(this.options.classes.active);
  }

  close() {
    enableBodyScroll(this.el);
    this.$el.removeClass(this.options.classes.active);
  }
}
